import { Component, Input, signal } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { Taxonomy } from '../taxonomy.model';
import { ConfirmPopupService } from '../../../services/confirm-popup.service';
import { PopupConfirmationData } from '../../../shared/constant';
import { TaxonomyService } from '../../../services/taxonomy.service';
import { TaxonomyApiService } from '../../../services/api-services/taxonomy-api.service';
import { CustomDateTimePipe } from '../../../pipes/custom-date-time.pipe';
import { Router } from '@angular/router';

@Component({
  selector: 'taxonomy-card',
  standalone: true,
  imports: [CommonModule, CustomDateTimePipe],
  providers: [DatePipe],
  templateUrl: './taxonomy-card.component.html',
  styleUrl: './taxonomy-card.component.scss',
})
export class TaxonomyCardComponent {
  constructor(
    private confirmPopupService: ConfirmPopupService,
    private taxonomyService: TaxonomyService,
    private taxonomyApiService: TaxonomyApiService,
    private router: Router
  ) {}

  @Input() taxonomy!: Taxonomy;

  _showMoreDropdown = signal<boolean>(false);

  handleMorePress() {
    this._showMoreDropdown.set(!this._showMoreDropdown());
  }

  handleDeleteTaxonomy = (event: MouseEvent, taxonomyId: string) => {
    const taxonomyIdForDelete = {
      taxonomy_id: taxonomyId,
    };
    this._showMoreDropdown.set(false);
    this.confirmPopupService.openConfirmDialog(PopupConfirmationData.deleteTaxonomyConfirmation).subscribe((result) => {
      if (result?.data?.confirm) {
        this.taxonomyApiService.deleteTaxonomyV2(taxonomyIdForDelete).subscribe(() => {
          this.taxonomyService.loadTaxonomy();
          this.taxonomyService.getTaxonomiesData();
        });
      }
    });
  };

  handleViewTaxonomy(event: MouseEvent, taxonomyId: string, taxonomyName: string) {
    const selectedValue = {
      taxonomy_id: taxonomyId,
      taxonomy_name: taxonomyName,
    };
    this.taxonomyService.setSelectedValue(selectedValue);
  }

  handleRenameTaxonomy(event: MouseEvent, taxonomyId: string, taxonomyName: string) {
    const selectedValue = {
      taxonomy_id: taxonomyId,
      taxonomy_name: taxonomyName,
    };
    this.taxonomyService.setSelectedValue(selectedValue);

    this.router.navigate(['/settings']);
  }
}
